import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissionHelper";
import { PERMISSIONS } from "constants/permissionTypes";
import { MODULES } from "constants/modulesTypes";
import { Link, useSearchParams, useNavigate, useParams } from "react-router-dom";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";

var data = "";

const RolePermission = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { id } = useParams();

    const [Roledata, setRoleData] = useState();
    const [RolePermissiondata, setRolePermissionData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [Moduledata, setModuleData] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [uncheckedItems, setUncheckedItems] = useState([]);

    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem("authUser"));

    useEffect(() => {
        getRoleById();
        getActiveModules();
        getRolePermissionByRoleId();
    }, []);

    const permissionMap = useSelector(
        state => state.permissions?.permissions || {}
    );

    const getRoleById = async () => {
        try {
            let url = `https://api.kunalsdrumclass.com/api/GetRoleById?id=${id}`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const jsonData = await response.json();
            setRoleData(jsonData.recordsets[0]);
            data = jsonData.recordsets[0][0];
        } catch (error) {
            console.error(error);
        }
    };

    const getActiveModules = async () => {
        try {
            const response = await fetch("https://api.kunalsdrumclass.com/api/GetActiveModules", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const jsonData = await response.json();
            setModuleData(jsonData.recordsets[0]);
        } catch (error) {
            console.error(error);
        }
    };

    const getRolePermissionByRoleId = async () => {
        try {
            let url = `https://api.kunalsdrumclass.com/api/GetRolePermissionByRoleId?roleId=${id}`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const jsonData = await response.json();
            setRolePermissionData(jsonData.recordsets[0]);

            const checkedModuleIds = [
                ...new Set(jsonData.recordsets[0].map(item => item.Module_Id))
            ];
            setCheckedItems(checkedModuleIds);
        } catch (error) {
            console.error(error);
        }
    };

    const handleCheckboxChange = (id) => {
        setCheckedItems(prev => {
            if (prev.includes(id)) {
                setUncheckedItems(u => [...u, id]);
                return prev.filter(item => item !== id);
            } else {
                setUncheckedItems(u => u.filter(item => item !== id));
                return [...prev, id];
            }
        });
    };

    const handleSelectAll = () => {
        if (checkedItems.length === Moduledata.length) {
            setCheckedItems([]);
        } else {
            setCheckedItems(Moduledata.map(m => m.ID));
        }
    };

    async function saveRolePermission() {
        try {
            setLoading(true);
            let moduleIndex = 0;
            let iterations = 0;

            while (moduleIndex < uncheckedItems.length) {
                for (let i = 1; i <= 4; i++) {
                    if (moduleIndex >= uncheckedItems.length) break;

                    await fetch('https://api.kunalsdrumclass.com/api/DeleteRolePermissionByRoleId', {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            roleId: id,
                            moduleId: uncheckedItems[moduleIndex],
                            modifiedBy: user.Id
                        })
                    });

                    if (iterations === 3) {
                        moduleIndex++;
                        iterations = 0;
                    } else {
                        iterations++;
                    }
                }
            }

            moduleIndex = 0;
            iterations = 0;

            while (moduleIndex < checkedItems.length) {
                for (let i = 1; i <= 4; i++) {
                    if (moduleIndex >= checkedItems.length) break;

                    await fetch('https://api.kunalsdrumclass.com/api/RolePermission', {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            roleId: id,
                            moduleId: checkedItems[moduleIndex],
                            permissionId: i,
                            createdBy: user.Id,
                            modifiedBy: user.Id,
                            isActive: 1,
                            isDeleted: 0
                        })
                    });

                    if (iterations === 3) {
                        moduleIndex++;
                        iterations = 0;
                    } else {
                        iterations++;
                    }
                }
            }

            Swal.fire("Success!", "Role Permission saved successfully!", "success")
                .then(() => navigate('/roles'));

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Role Permission"
                        breadcrumbItems={[
                            { title: "Roles", link: "/roles" },
                            { title: "Role Permission" }
                        ]}
                    />

                    <div className="d-flex justify-content-end mb-3">
                        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                            Back to List
                        </button>
                    </div>

                    <h5>Role: {data?.Name}</h5>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h6>Modules</h6>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={checkedItems.length === Moduledata.length}
                                onChange={handleSelectAll}
                            />
                            <label className="form-check-label">
                                Select All
                            </label>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: "60px" }}>#</th>
                                            <th>Module Name</th>
                                            <th className="text-center" style={{ width: "150px" }}>
                                                Permission
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {Moduledata.length > 0 ? (
                                            Moduledata.map((module, index) => (
                                                <tr key={module.ID}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span>{module.Name}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="form-check d-flex justify-content-center">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input custom-checkbox"
                                                                checked={checkedItems.includes(module.ID)}
                                                                onChange={() => handleCheckboxChange(module.ID)}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted py-4">
                                                    No modules found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {hasPermission(permissionMap, MODULES.ROLEPERMISSION, PERMISSIONS.INSERT) && (
                                <div style={{ textAlign: "right", marginTop: "1rem" }}>
                                    <button className="btn btn-primary" onClick={saveRolePermission} disabled={loading}>
                                        Save
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default RolePermission;
